import ReactOnRails from "react-on-rails";
import EventSearchBar from "../bundles/EventSearchBar";
import EnhancedSearchBar from "../bundles/EnhancedSearchBar";
import SearchBarWrapper from "../bundles/EnhancedSearchBar/SearchBarWrapper";
import UnifiedSearchResults from "../bundles/EnhancedSearchBar/UnifiedSearchResults";
import "flatpickr/dist/flatpickr.min.css";

ReactOnRails.register({
  EventSearchBar,
  EnhancedSearchBar,
  SearchBarWrapper,
  UnifiedSearchResults
});
